import { Typography } from '@mui/material';

export function Title({ isHeading = false }: { isHeading?: boolean }) {
  return (
    <Typography
      sx={{ letterSpacing: '0.05rem', fontWeight: 450 }}
      component={isHeading ? 'h2' : 'span'}
      {...(isHeading && { id: 'on-this-page' })}
    >
      ON THIS PAGE
    </Typography>
  );
}
